const NavBar = () => {
  return (
    <div className="nav-bar"/>
  )
}

export default NavBar;

